import { motion } from 'framer-motion';
import React from 'react';
import { useHistory } from 'react-router-dom';
import '../../Styles/Projects/ProjectsPage.css';
import HomePageBackgroundEffect from '../Animation/HomeBackgroundEffect';
import FacebookProject from './FacebookProject';
import MilaapProject from './MilaapProject';
import TravelBookingProject from './TravelBookingProject';

const ProjectsPage = () => {

    const history = useHistory();

    return (
        <motion.div className="projects-main-container flex-box" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.5 }}>
            <HomePageBackgroundEffect />
            <h1 className="project-main-title">Projects</h1>
            <FacebookProject />
            <MilaapProject />
            <TravelBookingProject />
            <div className="flex-box projects-page-buttons-container">
                <div className="projects-page-button project-page-button-left" onClick={() => history.push(`/about`)}>About me</div>
                <div className="projects-page-button project-page-button-right" onClick={() => history.push(`/blog`)}>Read blogs</div>
            </div>
        </motion.div>
    )
}

export default ProjectsPage
